var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[_c('div',{staticClass:"notice_con"},[_c('div',{staticClass:"notice_icon_con"},[_c('img',{staticClass:"full_img",attrs:{"src":_vm.datas.iconImgUrl ? _vm.datas.iconImgUrl : _vm.defaultImg,"alt":""}})]),_c('div',{staticClass:"scroll-container",style:({ height: `${_vm.height}px` })},_vm._l((_vm.list),function(item,index){return _c('ul',{key:index,staticClass:"scroll-ul",style:({
            transform: `translate3d(0, ${_vm.y}px, 0)`,
            transition: `${_vm.transition}`,
          }),on:{"click":function($event){return _vm.handleClickImg(item)}}},[_c('li',{staticClass:"c-item",style:({
              height: _vm.heightArr[_vm.datas.styleType - 1] + 'px',
              'line-height': _vm.heightArr[_vm.datas.styleType - 1] + 'px',
            })},[(item.content)?_c('div',{staticClass:"c-content",style:({
                'font-size': _vm.datas.wordSize + 'px',
                'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
                'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
                'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
                color: _vm.datas.wordColor,
              })},[_vm._v(" "+_vm._s(item.content)+" ")]):_vm._e()])])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }